<template>
	<div class="MarketingErrors">
		<!-- <div class="bntGroup">
			<base-button @click="GoBack()" type="primary" class="no-border my-0" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
		</div> -->
		<div class="filter-tag-row">
			<ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
			<span v-if="this.ApiData" class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Объектов: {{this.masApi_total}}</span>
		</div> 
		
		<div class="row" v-show="bShowFilter">
			<div class="col-12"><ReFilter
				:masAllFilterParams="masAllFilterParams"
				v-model="objGetParams"
				v-on:filterapply="OnFilterApply"
				name="MarketingErrors-"
			/></div>
		</div>

		<h6 class="d-inline-flex align-items-center"> <i class="tim-icons text-danger icon-alert-circle-exc mr-1"></i> Информация об ошибках обновляется один раз в сутки (ночью). 
			Если вы исправили проблему, проверьте наличие ошибок на следущий день!</h6>	
		<card>
			<el-table 
			:data="ApiData" 
			style="width: 100%;"
			v-loading.fullscreen.lock="$GVO.fullscreenLoading"
			element-loading-text="Загрузка данных..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"
			>
				<el-table-column 
					type="index"
					width="80"
					
				>
				</el-table-column>
				<el-table-column
					label="Объект"
					property="id"
					width="180"
				>
					<template v-slot="scope">	
						<router-link :to="'/data/module/mo/object/'+scope.row.id+'/edit'">Объект ID {{scope.row.id}}</router-link>
					</template>
				</el-table-column>

				<el-table-column 
					min-width="200"
					label="Описание проблемы"
					property="errors"
				>
				</el-table-column>

				<el-table-column 
					min-width="200"
					label="Ответственный"
					property="agent_fio"
				>
					<template v-slot="scope">
						<router-link :to="'/data/staff/id/'+scope.row.agent_id">{{scope.row.agent_fio}}</router-link>
					</template>
				</el-table-column>
				<el-table-column 
					min-width="200"
					label="Название площадки"
					property="site"
					
				>
				</el-table-column>
			
			</el-table>


		</card>
		<Pagination class="mt-3" :class="[{'': parseInt(masApi_total) > 0}, {'d-none': parseInt(masApi_total) < 1}]"
			:type="'info'" 
			:total="parseInt(masApi_total)" 
			:perPage="parseInt(c2p)"
			:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
			:pClick="pClick">
		</Pagination>
	</div>
</template>
<script>
import {eventEmitter} from "src/plugins/globalComponents.js";
// import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import Pagination from 'src/our_components/RePagination';
import { Table, TableColumn, Select, Option, Tooltip, Button } from 'element-ui';

export default {
	name: 'MarketingErrors-page',
	components: {
        // ReFormPrinter,
		ReFilter,
		ReFilterBtn,
		Pagination,
		[Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
	},
	data() {
		return {
			ApiData: [],
			bShowFilter: false,
			objGetParams: {},
			masAllFilterParams: this.currentFilterConfig(),
			masApi_total:0,
			c2p: 10,
			dSearchType: 'errors',
		};
	},
	watch: {
		'$route' (to, from) {
			//console.log(to);
			//console.log(from);
			this.getApiData(); // перенёс из OnFilterApply
		}
	},
	methods: {
		
		getApiData(){
			let filter = {};

			this.objGetParams = this.$GVO.GetAllGet();
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				// if(typeof this.objGetParams.dSearchType !='undefined') this.dSearchType = 'errors';
				if(typeof this.objGetParams.dSearchType !='undefined') this.dSearchType = this.objGetParams.dSearchType;

				//console.log('getApi',this.objGetParams);
				filter = this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams));
			}

			//SGVO.ApiCall('GET_ALL_ERRORS',{obj:'MyObj',flt:{c2p:100}})
			this.$GVO.ApiCall('MyObj.GET_ALL_ERRORS',{flt:{/*'act':1,*/ ...filter, c2p:this.c2p}})
			.then((objApi) => {
				this.ApiData = [];
				this.masApi_total=0;
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
						if(objApi.total!=undefined) { this.masApi_total=objApi.total; }
					}else{
						this.ApiData=[];
						this.masApi_total=0; 
					}
				}
			}).catch(errorObjApi => {console.error(errorObjApi); this.masApi_total=0; this.ApiData = [];});
		},

		OnFilterApply(strItogGetParams){ // применяет параметры из фильтра и запускает запрос к АПИ
			// console.log('OnFilterApply0',strItogGetParams);
			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
				}
			}
			if(strItogGetParams == undefined){
				let objItogGetParams = this.$GVO.GetAllGet();

				if(typeof objItogGetParams.dSearchType !='undefined') {
					if(['mobj','lead','objmap', 'errors'].indexOf(objItogGetParams.dSearchType)==-1)objItogGetParams.dSearchType = 'errors';
				}
				
				if(typeof objItogGetParams.dSearchType !='undefined' && this.dSearchType != objItogGetParams.dSearchType) {
					objItogGetParams.dSearchType = this.dSearchType;
					if(typeof objItogGetParams['p'] != 'undefined'){
						delete objItogGetParams['p'];
					}
				}
				strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
				// console.log(strItogGetParams);
			}
			else {
				let tempStr = this.$GVO.ObjToQueryString(strItogGetParams).substr(1);
				// if(this.masObjects_total< objItogGetParams['p']*this.c2p){}
				// objItogGetParams['p']=1;
				strItogGetParams = tempStr;
				// console.log(objItogGetParams);
			}
			// console.log(strItogGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
		},
		currentFilterConfig(){
			this.$GVO.ApiCall('GET_FILTER_ERRORS',{obj:'MyObj'})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						this.masAllFilterParams = objApi.config;
						// this.masAllFilterParams = this.$GVO.unlinkObject(objApi.config);
						eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		pClick(e){
			let strItogGetParams = '';
			let objItogGetParams = this.$GVO.GetAllGet();
			
			objItogGetParams.p=parseInt(e);
			strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			// this.OnFilterApply(strItogGetParams);
		},
	},		
	mounted() {
		var queryParams = new URLSearchParams(window.location.search);
		queryParams.set("dSearchType", "errors");
		history.replaceState(null, null, "?"+queryParams.toString());
		this.objGetParams = this.$GVO.GetAllGet();
		this.getApiData();
	}
};
</script>
<style scoped>
.MarketingErrors .bntGroup{
	position: absolute;
	z-index: 1;
	right: 40px;
}
</style>
